import { Controller } from "@hotwired/stimulus";
import i18n from "../lib/i18n";

export default class extends Controller {
  static targets = ["ignore"];

  connect() {
    this.element.addEventListener("click", this.handleClick.bind(this));
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleClick.bind(this));
  }

  async handleClick(event) {
    const slideIn = document.getElementById("slidein-pane");

    if (!slideIn || !slideIn.classList.contains("active-pane")) {
      return;
    }

    if (this.shouldIgnore(event.target) || slideIn.contains(event.target)) {
      return;
    }

    const turboConfirmElement = slideIn.querySelector(
      "[data-controller='turbo-confirm']"
    );

    if (turboConfirmElement) {
      const turboConfirmController =
        this.application.getControllerForElementAndIdentifier(
          turboConfirmElement,
          "turbo-confirm"
        );

      if (turboConfirmController && !turboConfirmController.confirmClose()) {
        return;
      }
    }

    this.closeSlideInPane();
  }

  shouldIgnore(target) {
    return this.ignoreTargets.some((ignoreTarget) =>
      ignoreTarget.contains(target)
    );
  }

  closeSlideInPane() {
    fetch("/actions/*/close", {
      method: "GET",
      headers: { Accept: "text/vnd.turbo-stream.html" },
    })
      .then((res) => res.text())
      .then((html) => {
        document.getElementById("action_pop_out").innerHTML = html;
      });
  }
}
